import Icon from '@/components/snippets/icon/icon'
import { FilterItem } from 'libs/searchspring/components/collection/filters/FilterItem'
import { FilterSelected } from 'libs/searchspring/components/collection/filters/FilterSelected'
import { useFilters } from 'libs/searchspring/hooks/useFilters'
import { useInfiniteScrollResults } from 'libs/searchspring/hooks/useInfiniteScrollResults'
import { useEffect, useRef } from 'preact/hooks'
import { scrollHistoryManager } from 'helpers/scroll-history'
import { FilterSortAccordion } from 'libs/searchspring/components/collection/filters/FilterSortAccordion'

export function FilterDrawer({ id = 'filters', showFilters = false }) {
  const {
    handleClearFilters,
    handleToggleFilter,
    handleRemoveFilter,
    initialFilters,
    activeFilters,
    fetchedFilters
  } = useFilters()

  const { results, isLoading } = useInfiniteScrollResults()
  const totalResults = results?.pagination?.totalResults || 0
  const initialLoadDone = useRef(false)
  const isDesktop = useRef(window.innerWidth >= 1024)
  const isSearch = scrollHistoryManager.getPageType() === 'search'

  useEffect(() => {
    if (showFilters && isDesktop.current && !initialLoadDone.current) {
      // For search pages, we don't wait for isLoading
      if (isSearch) {
        setTimeout(() => {
          document.querySelector('#toggle-filters')?.click()
          initialLoadDone.current = true
        }, 100)
      } else if (!isLoading && results) {
        document.querySelector('#toggle-filters')?.click()
        initialLoadDone.current = true
      }
    }
  }, [isLoading, results, showFilters, isSearch])

  return (
    <x-modal
      className="group/filters z-60"
      data-id={id}
    >
      <div className="flex flex-col fixed top-0 left-0 w-full h-view pointer-events-none group-data-visible/filters:pointer-events-auto z-60 transition-all">
        <div
          className="flex flex-col w-full h-full max-w-[335px] lg:max-w-[488px] bg-secondary -translate-x-full-margin group-data-visible/filters:translate-x-0 z-2 transition-all"
        >
          <div class="shrink-0 flex flex-col pt-0.25">
            <div className="flex gap-x-gutter  px-1 items-center justify-between w-full h-[52px] border-b border-neutral-medium">
              <h4 className="h4 font-medium">Filter</h4>
              <button
                className="size-[13px] children:size-full"
                data-modal-parent={id}
                data-modal-role="close"
                aria-label="Close Filters"
              >
                <Icon id="close" />
              </button>
            </div>
            <FilterSelected activeFilters={activeFilters} onRemove={handleRemoveFilter} onClear={handleClearFilters} />
          </div>
          <div className="grow flex flex-col overflow-y-scroll lg:px-1 no-scrollbar overscroll-none">
            <FilterSortAccordion />
            {initialFilters.length > 0 ? (
              initialFilters.map((filter) => (
                <FilterItem
                  filter={filter}
                  onFilter={handleToggleFilter}
                  fetchedFilters={fetchedFilters}
                  activeFilters={activeFilters}
                  key={filter.field}
                />
              ))
            ) : (
              <p className="px-margin py-1 text-neutral-secondary">No filters available</p>
            )}
          </div>
          <div className='shrink-0 flex gap-x-gutter w-full px-1 py-1.25'>
            {activeFilters.size > 0 && (
              <button
                className='btn btn-primary btn-border btn-m'
                onClick={handleClearFilters}
                aria-label='Clear Filters'
              >
                Clear
              </button>
            )}
            <button
              className='grow btn btn-primary btn-fill btn-m'
              data-modal-parent={id}
              data-modal-role='close'
              aria-label='View Results'
            >
              View {totalResults} Results
            </button>
          </div>
        </div>
        <button
          class='fixed inset-tl size-full bg-neutral-black/60 opacity-0 group-data-visible/filters:opacity-100 pointer-events-none group-data-visible/filters:pointer-events-auto cursor-w-resize transition-all'
          data-modal-parent={id}
          data-modal-role='close'
          aria-label='Close Filters'
        />
      </div>
    </x-modal>
  )
}
